import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { environment } from '../environments/environment';

export enum MenuRootRoute {
  CHAT = 'chat',
}

// Local-dev bypass: no MSAL route guard when auth is disabled.
const chatGuards = environment.disableAuth ? [] : [MsalGuard];

export const ROUTES: Route[] = [
  {
    path: MenuRootRoute.CHAT,
    loadComponent: () =>
      import(
        './features/chatbot/feature/chatbot-feature.component'
        ).then(mod => mod.ChatbotFeatureComponent),
    canActivate: chatGuards
  },
  {
    path: '**',
    redirectTo: MenuRootRoute.CHAT
  }
];
